/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS10 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_9;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_10;
    },
    getDownloadName() {
      return ns.IOS10.nice_name;
    },
  });

  Object.assign(IOS10, {
    slug: `ios_10`,
    nice_name: `iOS 10 adoption`,
    description: `How quickly are consumers upgrading to iOS 10?`,
  });
  ns.IOS10 = IOS10;
});

}.call(window));